import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getNestedStructureBranchingQuery } from '@iotv/datamodel';
import { AppValueTypes, Traversal } from '@iotv/iotv-v3-types';
import React, { useContext, useEffect, useMemo } from 'react';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { useMostProximateCustomer } from '../../../hooks/useMostProximateCustomer';
import { AdjacentType } from '../../../types';
import { Listerlizer } from '../../factories/Listerlizer/Listerlizer';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ListerlizerWidget = (props) => {
    const mostProximateCustomer = useMostProximateCustomer({ item: props.user });
    const [{ applicationData }] = useContext(AppMainViewContext);
    const [branchingQueryDefinition, setBranchingQueryDefinition] = React.useState();
    useEffect(() => {
        if (props.contextCustomer) {
            const query = getNestedStructureBranchingQuery({
                traversal: Traversal.DESCENDING,
                groupObjectType: 'Group',
                containedObjectType: 'User',
                includeSupportedTypeInstances: true,
            });
            if (query)
                setBranchingQueryDefinition(query);
        }
    }, [props.contextCustomer]);
    const component = useMemo(() => props.contextCustomer && branchingQueryDefinition ? (_jsx(Listerlizer, { adjacentFilter: {
            adjacentType: AdjacentType.CHILD,
            objectType: 'User',
        }, viewObject: {
            matchedPrimary: props.contextCustomer,
            matchedRelatedByPk: [],
            matchedRelatedBySk: [],
        }, mostProximateCustomer: mostProximateCustomer, contextObject: props.contextCustomer, userFunctions: props.userFunctions, viewDefinition: {
            name: {
                key: 'name',
                label: 'Name',
                type: AppValueTypes.STRING,
                editable: false,
            },
        }, transactionFunctions: props.transactionFunctions, searchRootObjects: undefined, linkableItemsBranchingQueryDefinition: branchingQueryDefinition, linkableItemsResultFilter: { objectTypeId: 'User' }, applicationData: applicationData })) : (_jsx(_Fragment, {})), [props.contextCustomer, branchingQueryDefinition, mostProximateCustomer, applicationData?.getContainedItems()]);
    return {
        name: 'Listerlizer',
        category: 'composite',
        component,
    };
};
